import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Table, Popconfirm, message, Button, Modal, Form, Input, InputNumber, Divider } from 'antd'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { db } from '../../../config/Fire'
import * as Constants from '../../../constants'
import moment from 'moment'

const EditableTableProjects = (props) => {
	const [data, setData] = useState(props.data)
	const [isSaving, setIsSaving] = useState('')

	const [editModalVisible, setEditModalVisible] = useState(false)
	const [editingRecord, setEditingRecord] = useState(null)
	const [editForm] = Form.useForm()

	useEffect(() => {
		setData(props.data)
	}, [props.data])

	const columns = [
		{
			title: 'Nombre',
			dataIndex: 'name',
			width: '20%',
			align: 'center',
			sorter: (a, b) => a.name.localeCompare(b.name),
		},
		{
			title: 'Latitud',
			dataIndex: 'latitude',
			width: '15%',
			align: 'center',
			sorter: (a, b) => a.latitude - b.latitude,
			render: (value) => value != null ? value.toFixed(6) : '-'
		},
		{
			title: 'Longitud',
			dataIndex: 'longitude',
			width: '15%',
			align: 'center',
			sorter: (a, b) => a.longitude - b.longitude,
			render: (value) => value != null ? value.toFixed(6) : '-'
		},
		{
			title: 'Horas de traslado',
			dataIndex: 'travelHours',
			width: '15%',
			align: 'center',
			sorter: (a, b) => (a.travelHours || 0) - (b.travelHours || 0),
			render: (value) => value != null ? value.toFixed(2) : '0.00'
		},
		{
			title: 'Fecha de creación',
			dataIndex: 'createDate',
			width: '20%',
			align: 'center',
			render: (value) => {
				return moment(value, "DD/MM/YYYY HH:mm").format("HH:mm DD/MM/YYYY")
			}
		},
		{
			title: 'Operación',
			dataIndex: 'operation',
			width: '15%',
			align: 'center',
			render: (text, record) => {
				return (
					<span>
						<span>
							{
								props.showEditButton && (
									<>
										<Button onClick={() => openEditModal(record)}><EditOutlined style={{ color: 'blue' }} /></Button>
										<Divider type="vertical" />
									</>
								)
							}
							{
								isSaving === record.id ?
									<Button disabled><DeleteOutlined /></Button>
									:
									<Popconfirm title="¿Eliminar proyecto?" onConfirm={() => remove(record.id)}>
										<Button><DeleteOutlined style={{ color: 'red' }} /></Button>
									</Popconfirm>
							}
						</span>
					</span>
				)
			},
		},
	]

	const remove = id => {
		setIsSaving(id)
		db.ref(`${Constants.MAIN_NODES.PROJECTS}/${id}`).update({ isActive: false })
			.then(() => {
				message.success('¡El proyecto se eliminó exitósamente!')
				setIsSaving('')
			})
			.catch((err) => {
				message.error('Se produjo un error. Por favor, vuelva a intentarlo')
				console.log("Remove project error: " + err)
				setIsSaving('')
			})
	}

	const openEditModal = (record) => {
		setEditingRecord(record)
		editForm.setFieldsValue(record)
		setEditModalVisible(true)
	}

	const handleEditModalCancel = () => {
		setEditModalVisible(false)
		setEditingRecord(null)
		editForm.resetFields()
	}

	const handleEditModalOk = async () => {
		try {
			const values = await editForm.validateFields()
			setIsSaving('SAVING_MODAL')

			const updates = {
				...values,
				latitude: parseFloat(values.latitude),
				longitude: parseFloat(values.longitude),
				travelHours: values.travelHours ? Number(values.travelHours) : 0
			}

			db.ref(`${Constants.MAIN_NODES.PROJECTS}/${editingRecord.id}`).update(updates)
				.then(() => {
					message.success('¡El proyecto se modificó exitósamente!')
					setEditModalVisible(false)
					setEditingRecord(null)
					editForm.resetFields()
					setIsSaving('')
				})
				.catch((err) => {
					console.error(err)
					message.error('Error al actualizar proyecto.')
					setIsSaving('')
				})
		} catch (info) {
			console.log('Validate Failed:', info)
		}
	}

	return (
		<>
			<Table
				dataSource={data}
				columns={columns}
				rowKey="id"
				scroll={{ x: 1200 }}
				pagination={{ pageSize: 10 }}
			/>

			<Modal
				title="Editar Proyecto"
				visible={editModalVisible}
				onOk={handleEditModalOk}
				onCancel={handleEditModalCancel}
				confirmLoading={isSaving === 'SAVING_MODAL'}
				okText="Guardar"
				cancelText="Cancelar"
			>
				<Form
					form={editForm}
					layout="vertical"
					name="form_in_modal_project"
				>
					<Form.Item
						name="name"
						label="Nombre"
						rules={[{ required: true, message: 'Por favor ingrese el nombre del proyecto!' }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="latitude"
						label="Latitud"
						rules={[{ required: true, message: 'Por favor ingrese la latitud!' }]}
					>
						<InputNumber
							style={{ width: '100%' }}
							step={0.000001}
							parser={value => value.replace(/[^\d.-]/g, '')}
						/>
					</Form.Item>
					<Form.Item
						name="longitude"
						label="Longitud"
						rules={[{ required: true, message: 'Por favor ingrese la longitud!' }]}
					>
						<InputNumber
							style={{ width: '100%' }}
							step={0.000001}
							parser={value => value.replace(/[^\d.-]/g, '')}
						/>
					</Form.Item>
					<Form.Item
						name="travelHours"
						label="Horas de traslado"
					>
						<InputNumber
							style={{ width: '100%' }}
							min={0}
							step={0.01}
							precision={2}
						/>
					</Form.Item>
				</Form>
			</Modal>
		</>
	)
}

EditableTableProjects.propTypes = {
	data: PropTypes.array,
}

export default EditableTableProjects

